<template>
  <div>
    <st-scrolly class="scrolly3d">
      <template v-slot:background="{slideIndex, progress}">
        <div v-if="toLoad">
          <three-d key="scrolly-three-d" :slide-index="slideIndex" :slide-progress="getSlideProgress(slideIndex, progress)" :attributes="attributes"></three-d>
        </div>
      </template>

      <template >
        <div :key="-1" class="slide"></div>
        <div v-for="(item, key) in attributes.value" :key="key" :class="['slide', {hasmedia: item.image || item.video}]">
          <div class="card" :data-key="key">
            <div class="card-text">
              <div v-if="item.title" class="title" v-markdown="item.title" />
              <div v-if="item.subtitle" class="subtitle" v-markdown="item.subtitle" />
              <span v-for="(deck, keyd) in item.deck" :key="keyd" class="deck" v-markdown="deck" />
            </div>
            <img v-if="item.image && !item.video" class="card-img" :src="getSource(item.image)" />
            <video v-if="item.video" class="card-img" muted playsinline controls :poster="getSource(item.image)" preload="metadata" :src="getSource(item.video + '#t=0.1', true)" >
            </video>
          </div>
        </div>
      </template>

      <template v-slot:foreground v-if="!attributes.noar">
        <div :class="['scrolly3d-viewar', {isdesktop: !isMobile}]">
          <viewar :attributes="{ioslink: attributes.ioslink, androidlink: attributes.androidlink}"/>
        </div>
      </template>

    </st-scrolly>
    <!-- <div class="scrolly3d-viewar" v-if="!isMobile && !attributes.noar">
      <viewar :attributes="{ioslink: attributes.ioslink, androidlink:attributes.androidlink}"/>
    </div> -->
  </div>
</template>

<script>
import StScrolly from '@st-graphics/scrolly'
import '@st-graphics/scrolly/dist/bundle.css'
import ThreeD from './3D/index.vue'
import Viewar from './viewar.vue'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'

export default {
  props: ['attributes'],
  components: {
    StScrolly,
    ThreeD,
    Viewar
  },
  data () {
    return {
      toLoad: false,
      currentSlideIndex: -1
    }
  },
  computed: {
    isMobile () {
      return window.browserInfo.mobile
      // return (/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera)
    }
  },
  watch: {
    currentSlideIndex: function (newVal, oldVal) {
      this.viewARPosition()
    }
  },
  methods: {
    getSource (value, isVideo) {
      if (!value) return null
      try {
        if (isVideo) {
          return require(`videos/${value}`)
        } else {
          return require(`images/${value}`)
        }
      } catch (err) {
        return value
      }
    },
    getSlideProgress (slideIndex, progress) {
      this.currentSlideIndex = slideIndex
      if (!progress) return 0
      return progress.at(slideIndex, slideIndex + 1)()
    },
    isVisible (el, offsetTop = 0.7, offsetBottom = 0.3) {
      if (!el) return false
      const rect = el.getBoundingClientRect()
      const isVisible =
        rect.bottom > rect.height * +offsetBottom &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) * +offsetTop /* or $(window).height() */

      return isVisible
    },
    viewARPosition () {
      if (this.isMobile) {
        let viewarEl = this.$el.querySelector('.scrolly3d-viewar')
        let viewarHeight = viewarEl.clientHeight
        if (this.currentSlideIndex < this.attributes.value.length) {
          viewarEl.style.bottom = 'unset'
          viewarEl.style.top = window.innerHeight - viewarHeight - 40 + 'px'
        } else {
          viewarEl.style.top = 'unset'
          viewarEl.style.bottom = '40px'
        }
      }
    }
  },
  mounted () {
    const _this = this
    document.addEventListener('scroll', throttle(function () {
      if (!_this.toLoad && _this.isVisible(_this.$el, 1, 0)) {
        _this.toLoad = true
      } else if (!_this.isVisible(_this.$el, 1, 0)) {
        _this.toLoad = false
      }
    }, 100))
    window.addEventListener('resize', debounce(function () {
      _this.viewARPosition()
    }, 100))
  }
}
</script>
<style lang="scss">
.component.component-scrolly3d {
  position: relative;
  background-color: #97A1A7;
  padding: 0;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
  transform: translate3d(0, 0, 0);
  .slide-container {
    max-width: 1400px;
  }
  .scrolly3d-viewar {
    padding: 10px 0;
    text-align: center;
    width: 100%;
    position: absolute;
    top: calc(100vh - 100px);
    left: 50%;
    transform: translateX(-50%);
    transition: top 0.5s ease-in-out, bottom 0.5s ease-in-out;
  }
}
.scrolly3d {
  .background-container {
    z-index: -1;
  }

  .slide {
    height: 120vh;
    position: relative;
    &:last-of-type.hasmedia {
      padding-bottom: 145vh;
    }
    .card {
      margin: 0 auto;
      @media (min-width: $d_medium) {
        margin-left: 1vw;
        width: 400px;
        max-width: 85vw;
      }
      .card-img {
        width: 100%;
        transition: transform 0.5s ease-in-out;
        &:hover {
          transform:scale(1.12);
        }
      }
      .card-text {
        padding: 10px 10px 10px 0;
        white-space: break-spaces;
        overflow-x: hidden;
      }
      .title {
        padding: 0px 15px;
        font-family: $font-CuratorRegular;
        font-size: 15px;
        text-transform: uppercase;
        color: #263B47;
      }
      .yellow {
        color: #fff200;
      }
      .subtitle {
        font-size: 45px;
        line-height: 49px;

        padding: 0px 10px;
        margin-bottom: 0;
        color: #FFF;
        font-family: $font-SelaneMinTen;
      }
      .deck {
        padding: 0px 10px;
        margin-bottom: 0;
        color: #FFF;
        background-color: rgb(0 0 0 / 30%);
        box-decoration-break: clone;
        font-family: $font-SelaneMinTen;
        @media (min-width: $d_medium) {
          background-color: unset;
          font-size: 29px;
          line-height: 42px;
        }
      }
      strong {
        font-weight: normal;
        color: #fff200;
      }
    }
  }
}

.component.component-scrolly3d {
  .scrolly3d-viewar.isdesktop {
    top: unset !important;
    bottom: 10px !important;
  }
}
</style>
